import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiFetch from './api';
import './css/Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Send as URL-encoded form data to match Spring Security's default formLogin
            const body = new URLSearchParams();
            body.append('username', formData.username);
            body.append('password', formData.password);

            const response = await apiFetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body.toString(),
            });

            // Spring's form login typically redirects on success; treat non-403/401 as success
            if (response.status === 401 || response.status === 403) {
                throw new Error('Invalid credentials');
            }

            // On success, navigate to the EventGeneratorForm route within the SPA
            navigate('/api/eventgenerator');
        } catch (error) {
            alert(error.message || 'Login failed.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
    <div className="login-container">
      <a
        href="https://wiki.spireon.com/pages/viewpage.action?spaceKey=STE&title=EventGenerationService"
        target="_blank"
        rel="noopener noreferrer"
        className="wiki-button"
      >
        Wiki
      </a>
      <div className="login-form-wrapper">
        <h2>Event Generator Login Page</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
